import {Injectable} from '@angular/core';
import {CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AppService} from '../app.service';
import {ApiService} from '../api.service';

@Injectable()
export class UserRoleGuardService implements CanActivate, CanActivateChild {

  constructor(private appService: AppService, private router: Router, private apiHttpService: ApiService) {

  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    let allowedRoles = route.data['allowedRoles'] ? route.data['allowedRoles'] : (route.parent.data['allowedRoles'] ? route.parent.data['allowedRoles'] : []);
    let hasRole = this.appService.userHasRoles(allowedRoles);
    return hasRole;
  }

  getAuthUserRoles(userId) {
    return this.apiHttpService.getAuthUserRoles(userId).map((resp: any) => {
      return Observable.of(resp.data);
    }).catch((error) => {
      return Observable.of(null);
    });
  }
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/utils/services/guards/user-role-guard.service.ts